import {
    Button,
    DetailsList,
    DetailsListLayoutMode,
    IconButton,
    MarqueeSelection, PrimaryButton, ScrollablePane,
    Selection,
    SelectionMode,
    SharedColors,
} from "@fluentui/react";
import * as React from "react";
import { useContext, useEffect, useState } from "react";
import AuthContext from "../../../Services/AuthContext";
import { MoneyField } from "../../../Utilities/MoneyField";
import { MoneyFormat } from "../../../Utilities/MoneyFormat";
import EditAgreementElement from "../../../Panel/AgreementElement/EditAgreementElement";
import { netGrossColumn, netGrossField } from "../../../Utilities/NetGrossField";
import { grayOutField } from "../../../Utilities/grayOutField";

function AgreementElementDataView(props) {
    const [user] = useContext(AuthContext);
    const [elements, setElements] = useState([]);
    const [sum, setSum] = useState(0);
    const [editElement, setEditElement] = useState(false);

    const [selection] = useState(new Selection({
        onSelectionChanged: () => setSum(selection.getSelection().reduce((p, c) => p + parseFloat(c[netGrossField('', 'total')]), 0)),
    }));

    const [sort, setSort] = useState({ key: null });
    useEffect(() => {
        if (sort.key !== null) {
            const newColumns = columns.slice();
            const currColumn = newColumns.filter(currCol => sort.key === currCol.key)[0];
            newColumns.forEach((newCol) => {
                if (newCol === currColumn) {
                    currColumn.isSortedDescending = !currColumn.isSortedDescending;
                    currColumn.isSorted = true;
                } else {
                    newCol.isSorted = false;
                    newCol.isSortedDescending = true;
                }
            });
            setColumns(newColumns);
            const items = props.items.slice(0).sort((a, b) => ((currColumn?.isSortedDescending ? a[sort.key] < b[sort.key] : a[sort.key] > b[sort.key]) ? 1 : -1));
            setElements(items);
        }
    }, [sort]);

    useEffect(() => {
        if (sort.key === null) {
            setElements(props.items);
        } else {
            const newColumns = columns.slice();
            const currColumn = newColumns.filter(currCol => sort.key === currCol.key)[0];
            const items = props.items.slice(0).sort((a, b) => ((currColumn?.isSortedDescending ? a[sort.key] < b[sort.key] : a[sort.key] > b[sort.key]) ? 1 : -1));
            setElements(items);
        }
    }, [props.items]);
    const _sort = (e, col) => setSort(col);

    const [columns, setColumns] = useState([]);
    useEffect(() => {
        const left = props.showLeft ? [{
            key: "quantity_left",
            name: "Pozostało",
            ariaLabel: "Pozostało",
            fieldName: "quantity_left",
            minWidth: 100,
            maxWidth: 100,
            isResizable: true,
        }] : [];
        setColumns([
            {
                key: "addon",
                name: "Nazwa",
                ariaLabel: "Nazwa",
                fieldName: "addon",
                minWidth: 210,
                isRowHeader: true,
                isResizable: true,
                onColumnClick: _sort,
                isSortedDescending: true,
                onRender: grayOutField('addon')
            },
            {
                key: "venture",
                name: "Kontrakt",
                ariaLabel: "Kontrakt",
                fieldName: "venture",
                minWidth: 150,
                isResizable: true,
                onColumnClick: _sort,
                onRender: grayOutField('venture')
            },
            {
                key: "note",
                name: "Notatka",
                ariaLabel: "Notatka",
                fieldName: "note",
                minWidth: 100,
                isResizable: true,
                onRender: grayOutField('note')
            },
            {
                minWidth: 210,
                maxWidth: 210,
                ...netGrossColumn('', 'value', 'Koszt ')
            },
            ...left,
            {
                key: "quantity",
                name: "Ilość",
                ariaLabel: "Ilość",
                fieldName: "quantity",
                minWidth: 200,
                maxWidth: 200,
                isResizable: true,
                onRender: (item) => item.quantity_left !== null & item.quantity - item.quantity_left  > 0
                    ? <span style={{color: "red"}}>{item.quantity}</span>
                    : item.quantity
            },
            {
                minWidth: 210,
                maxWidth: 210,
                ...netGrossColumn('', 'total', 'Wartość ')
            },
            {
                key: "edit",
                name: "Akcje",
                ariaLabel: "Akcje",
                fieldName: "edit",
                minWidth: 70,
                maxWidth: 70,
                onRender: (item) => {
                    const deleteButton = item.parent_element === null ? <IconButton iconProps={{ iconName: "delete" }} title="Usuń" onDoubleClick={() => _deleteCost(item)} /> : '';
                    return (<span>
                    <IconButton iconProps={{ iconName: "edit" }} title="Edytuj" onClick={() => setEditElement(item)} />
                        {deleteButton}
                </span>)},
            },
        ]);
    }, [props.netGross]);


    const _deleteCost = (item) => {
        fetch(`/api/agreement/element/${item.id}`, {
            method: "DELETE",
            headers: {
                "Authorization": "Bearer " + user.token,
            },
        }).then(res => res.json())
            .then(json => {
                props.refresh();
            })
            .catch(err => {
                console.log(err);
            });
    };

    const _clearQuantity = () => {
        fetch(`/api/agreement/element/clear`, {
            method: "PUT",
            body: JSON.stringify(selection.getSelection().map((i) => i.id)),
            headers: {
                "Authorization": "Bearer " + user.token,
            },
        }).then(res => res.json())
            .then(json => {
                props.refresh();
            })
            .catch(err => {
                console.log(err);
            });
    };

    let summary = 0;
    let addons = 0;
    let internals = 0;
    let included = 0;
    elements.forEach((item) => {
        const cost = parseFloat(item[netGrossField('', 'total')]);
        summary += cost;
        if (item.internal) {
            internals += cost;
        } else if (item.deadline !== null && item.project_addon_id !== null) {
            addons += cost;
        } else {
            included += cost;
        }
    });
    let color = SharedColors.greenCyan10;
    if (summary - props.total > 0) {
        color = SharedColors.red10;
    } else if (summary - props.total < 0) {
        color = SharedColors.cyanBlue10;
    }

    return (
        <>
            <h4 style={{ color: color }}>{MoneyFormat(summary)} / {MoneyFormat(props.total)}</h4>
            <h5>Wewnętrzne: {MoneyFormat(internals)}, Dodatki: {MoneyFormat(addons)},
                Budowa: {MoneyFormat(included)}</h5>
            <h5>Zaznaczono: {MoneyFormat(sum)} {props.showClear && <PrimaryButton onClick={_clearQuantity}>Wyzeruj ilość</PrimaryButton>}</h5>
            <MarqueeSelection selection={selection}>
                <DetailsList items={elements}
                             columns={columns}
                             selectionMode={SelectionMode.multiple}
                             selection={selection}
                             selectionPreservedOnEmptyClick={true}
                             isHeaderVisible={true}
                             layoutMode={DetailsListLayoutMode.justified}
                />
            </MarqueeSelection>
            <EditAgreementElement add={editElement} onSuccess={props.refresh}
                                  dismissPanel={() => setEditElement(false)} />
        </>
    );
}

export default AgreementElementDataView;